var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PopupLayout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }